import { CircleCheck } from "lucide-react";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { IntroVideoUpload } from "../IntroVideoUpload";
import { Section, OptionalTag } from "./builderUi";

export const VideoSection = ({ campaignId }) => (
  <Section accent="bg-scarlet" title="Video pitch" subtitle="A short intro, recorded here or uploaded. Campaigns with a face and a voice get funded faster." badge={<OptionalTag />} testid="builder-video">
    <IntroVideoUpload campaignId={campaignId} />
  </Section>
);

const OPTIONS = [
  { v: "public", label: "Public profile", desc: "Discoverable by donors on My Rich Aunt" },
  { v: "private", label: "Private profile", desc: "Only reachable by people you share the link with" },
];

export const VisibilitySection = ({ value, onChange }) => (
  <Section accent="bg-grass" title="Profile visibility" subtitle="Choose whether your campaign is discoverable or link-only." testid="builder-visibility">
    <RadioGroup value={value} onValueChange={onChange} className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {OPTIONS.map((o) => (
        <label
          key={o.v}
          data-testid={`builder-visibility-${o.v}`}
          className={`flex cursor-pointer items-start gap-3 rounded-lg border p-4 transition-colors ${value === o.v ? "border-cobalt bg-cobalt/[0.04]" : "border-border bg-sand hover:border-cobalt/40"}`}
        >
          <RadioGroupItem value={o.v} className="mt-0.5" />
          <span>
            <span className="block text-[13px] font-semibold text-ink">{o.label}</span>
            <span className="block text-[13px] text-olive">{o.desc}</span>
          </span>
        </label>
      ))}
    </RadioGroup>
    {value === "public" && (
      <div className="mt-4 flex items-start gap-3 rounded-lg border border-yellow/50 bg-yellow/[0.14] p-4">
        <CircleCheck className="mt-0.5 h-5 w-5 shrink-0 text-tangerine" strokeWidth={1.75} />
        <p className="text-base leading-relaxed text-ink">
          Good choice. Public profiles raise more — donors want to hear from students like you, not from us.
        </p>
      </div>
    )}
  </Section>
);
